class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.notificationOverlay = document.getElementById('cart-notification-overlay');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);
    
    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());

    this.addEventListener('click', this.handleTermsClick.bind(this));
    this.addEventListener('keydown', this.handleTermsKeydown.bind(this));
    this.addEventListener('change', this.handleTermsChange.bind(this));
  }

  handleTermsChange(evt) {
    if (!evt.target.matches('.cart-notification__terms-input')) return;
    this.updateCartRulesAcceptedNote(evt.target.checked);
  }

  updateCartRulesAcceptedNote(checked) {
    fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ attributes: { rules_accepted: checked ? 'true' : 'false' } })
    });
  }

  handleTermsClick(evt) {
    const termsText = evt.target.closest('.cart-notification__terms-text');
    if (!termsText) return;
    if (evt.target.closest('a')) return;
    evt.preventDefault();
    const checkbox = this.querySelector('.cart-notification__terms-input');
    if (checkbox) {
      checkbox.checked = !checkbox.checked;
      checkbox.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  handleTermsKeydown(evt) {
    if (evt.target.closest('.cart-notification__terms-text') && evt.target.tagName !== 'A' && (evt.code === 'Enter' || evt.code === 'Space')) {
      evt.preventDefault();
      const checkbox = this.querySelector('.cart-notification__terms-input');
      if (checkbox) {
        checkbox.checked = !checkbox.checked;
        checkbox.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  }

  open() {
    this.notification.classList.add('animate', 'active');
    this.notificationOverlay.classList.add('show');

    this.notification.addEventListener('transitionend', () => {
      this.notification.focus();
      trapFocus(this.notification);
    }, { once: true });

    document.body.addEventListener('click', this.onBodyClick);

    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
        closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  close() {
    this.notification.classList.remove('active');
    this.notificationOverlay.classList.remove('show');

    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
      this.productId = parsedState.id;
      this.getSectionsToRender().forEach((section => {
        document.getElementById(section.id).innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }));

      this.header?.reveal();
      this.open();
  }

  renderCart(parsedState, cartText) {
    this.getCartSectionsToRender().forEach((section => {
      document.getElementById(section.id).innerHTML =
        this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    }));
    
    cartText.cartNotification.innerHTML = cartText.text.innerHTML;

    this.header?.reveal();
    this.open();
  }

  getCartSectionsToRender() {
    return [
      {
        id: 'cart-notification-button'
      },
      {
        id: 'cart-icon-bubble'
      }
    ]
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `#cart-notification-product-${this.productId}`,
      },
      {
        id: 'cart-notification-button'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if ((target !== this.notification && !target.closest('cart-notification') || target === this.notificationOverlay)) {
      const disclosure = target.closest('details-disclosure');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
